/**
 * Dekoder wire-format ParkState dla colyseus.js.
 * Pola = ParkPlayerPublic / ParkNpcPublic / ParkBallPublic z @pieskowo/shared.
 * NIE jest drugim SoT — tylko Schema serializer (serwer ma lustrzane klasy w WP3).
 */
import { Schema, MapSchema, defineTypes } from '@colyseus/schema';

export class ParkPlayerState extends Schema {
  declare sessionId: string;
  declare playerId: string;
  declare dogName: string;
  declare breed: string;
  declare color: string;
  declare x: number;
  declare y: number;
  declare tx: number;
  declare ty: number;
  declare anim: string;
  declare emote: string;
  declare outfit: string;
  declare connected: boolean;

  constructor() {
    super();
    // Keep assignments on Schema's generated prototype setters. Native ES2022
    // class fields would shadow those setters and drop every wire patch.
    this.sessionId = '';
    this.playerId = '';
    this.dogName = '';
    this.breed = '';
    this.color = '';
    this.x = 0;
    this.y = 0;
    this.tx = 0;
    this.ty = 0;
    this.anim = 'idle';
    this.emote = '';
    this.outfit = '{}';
    this.connected = true;
  }
}

defineTypes(ParkPlayerState, {
  sessionId: 'string',
  playerId: 'string',
  dogName: 'string',
  breed: 'string',
  color: 'string',
  x: 'number',
  y: 'number',
  tx: 'number',
  ty: 'number',
  anim: 'string',
  emote: 'string',
  outfit: 'string',
  connected: 'boolean',
});

export class ParkNpcState extends Schema {
  declare npcId: string;
  declare x: number;
  declare y: number;
  declare anim: string;
  declare emote: string;

  constructor() {
    super();
    this.npcId = '';
    this.x = 0;
    this.y = 0;
    this.anim = 'idle';
    this.emote = '';
  }
}

defineTypes(ParkNpcState, {
  npcId: 'string',
  x: 'number',
  y: 'number',
  anim: 'string',
  emote: 'string',
});

export class ParkBallState extends Schema {
  declare x: number;
  declare y: number;
  declare vx: number;
  declare vy: number;

  constructor() {
    super();
    this.x = 640;
    this.y = 360;
    this.vx = 0;
    this.vy = 0;
  }
}

defineTypes(ParkBallState, {
  x: 'number',
  y: 'number',
  vx: 'number',
  vy: 'number',
});

export class ParkState extends Schema {
  declare players: MapSchema<ParkPlayerState>;
  declare npcs: MapSchema<ParkNpcState>;
  declare ball: ParkBallState;

  constructor() {
    super();
    this.players = new MapSchema<ParkPlayerState>();
    this.npcs = new MapSchema<ParkNpcState>();
    this.ball = new ParkBallState();
  }
}

defineTypes(ParkState, {
  players: { map: ParkPlayerState },
  npcs: { map: ParkNpcState },
  ball: ParkBallState,
});
